import { render } from "./Error404.vue?vue&type=template&id=27d61d9a&scoped=true"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import "./Error404.vue?vue&type=style&index=0&id=27d61d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d61d9a"]])

export default __exports__